import { Dialog, DialogContent, DialogTitle, Grid, Tooltip } from "@mui/material";
import React from "react";
import { ActionLabels, appNote, ToasterTexts } from "../shared/constants";
import { LandlineSubscriberFormData, mapToSubscriber } from "../../models/add-phone-number.model";
import { PhoneNumberService } from "../../services/PhonenumberService";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TextLoader from "../shared/loaders/textbox-loader.json";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "./toaster/toaster.model";
import { CancelIcon, BackMobileIcon } from "../../icon";
interface IProps {
	ViewDetails: boolean;
	IsMobileDevice: boolean;
	PhoneNumberName: string;
	CloseViewDeatils: () => void;
	PhoneNumberID: string;
	IsDarkMode: boolean
}

interface IState extends LandlineSubscriberFormData {
	IsLoading: boolean;
}

class PhoneSubscriberDetailsComponent extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			AddressName: "",
			Address: "",
			City: "",
			Country: "",
			FirstName: "",
			HouseNumber: "",
			LastName: "",
			State: "",
			ZipCode: "",
			IsLoading: false
		}
	}


	componentDidMount = () => {
		this.setState({ IsLoading: true })
		PhoneNumberService.getSubscriberDetails(this.props.PhoneNumberID).then((res: any) => {
			this.setState({
				...mapToSubscriber(res.data),
				IsLoading: false
			})
		}).catch(err => {
			if (err.response.status === 404 || err.response.status === 400) {
				setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
				this.setState({ IsLoading: false })
			}
		})
	}


	render() {
		return (
			<>
				{
					!this.props.IsMobileDevice ? (
						<Dialog maxWidth="xs" open={this.props.ViewDetails}
							BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: `w-66 br-2 ${this.props.IsDarkMode ? "bg-color-sidebar-bg" : "dialogue-shadow"}` }}
						>
							<DialogTitle className={`dialog-h1 ${this.props.IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
								<div
									className={`h2-regular color-display-title d-flex`}
									id="customized-dialog-title"
								>
									{this.props.PhoneNumberName}
									<Tooltip title="Close" placement="bottom">
										<span className="ml-auto">
											<CancelIcon
												className={"c-pointer"}
												onClick={() => this.props.CloseViewDeatils()}
											/>
										</span>
									</Tooltip>
								</div>
							</DialogTitle>
							<DialogContent>
								<div className="br-1 settings-paper-border mb-2">
									<Grid container direction="row" spacing={2} className="p-2">
										<Grid item xs={12} md={12} lg={12} className="mt-1">
											<span className="h5-regular  color-text-field-label">
												Name
											</span>
											<br />
											<span className="h4-regular color-display-title">

												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
													</div>
													: this.state.AddressName || appNote.NOT_AVAILABLE}
											</span>
										</Grid>
										{/* <Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">
												Last Name
											</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
													</div>
													: this.state.LastName || appNote.NOT_AVAILABLE}
											</span>
										</Grid> */}
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">
												House Number
											</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto  w-11" />
													</div>
													: this.state.HouseNumber || appNote.NOT_AVAILABLE}
											</span>
										</Grid>
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">
												Street Name
											</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto  w-11" />
													</div>
													: this.state.Address || appNote.NOT_AVAILABLE}</span>
										</Grid>
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">
												Zip code
											</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto  w-11" />
													</div>
													: this.state.ZipCode || appNote.NOT_AVAILABLE}</span>
										</Grid>
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">City</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto  w-11" />
													</div>
													: this.state.City || appNote.NOT_AVAILABLE}</span>
										</Grid>
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular grid-header-font-color">State</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
													</div>
													: this.state.State || appNote.NOT_AVAILABLE}
											</span>
										</Grid>
										<Grid item xs={12} md={6} lg={6} className="mt-1">
											<span className="h5-regular  color-text-field-label">Country</span>
											<br />
											<span className="h4-regular color-display-title">
												{this.state.IsLoading ?
													<div className={"d-flex t-align-center c-pointer my-auto"}>
														<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
													</div>
													: this.state.Country || appNote.NOT_AVAILABLE}
											</span>
										</Grid>
									</Grid>
								</div>
							</DialogContent>
						</Dialog>
					) : (
						<>
							<div className="paper-background box-shadow-display-background-shadow d-flex w-fill p-2">
								<span>
									<BackMobileIcon
										className={"c-pointer pr-2"}
										onClick={() => this.props.CloseViewDeatils()}
									/>
								</span>
								<span className={`h3 d-inline-flex color-primary-accent mr-auto`}>
									{ActionLabels.VIEW_DETAILS}
								</span>
							</div>
							<div
								className=" w-fill h-v-92 bg-color-current-plan-background p-2 d-flex box-shadow-display-background-shadow"      >
								<div
									className="paper-background br-2 h-fit m-auto p-2" >
									<div
										className={` pb-2 h3 color-display-title d-flex`}
										id="customized-dialog-title"
									>
										{this.props.PhoneNumberName}
									</div>
									<div className="br-1 settings-paper-border mb-2">
										<Grid container direction="row" className="p-2">
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													First Name
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.FirstName || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													Last Name
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.LastName || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													House Number
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.HouseNumber || "NA"}
												</span>
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.HouseNumber || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													Street Name
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.Address || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													Zip code
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.ZipCode || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">City</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.City || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">State</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.State || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
											<Grid item xs={12} md={6} lg={6} className="mt-1">
												<span className="h4  color-text-field-label">
													Country
												</span>
												<br />
												<span className="h2 color-display-title">
													{this.state.IsLoading ?
														<div className={"d-flex t-align-center c-pointer my-auto"}>
															<AnimateLoader LoaderAnimation={TextLoader} className="my-auto w-11" />
														</div>
														: this.state.Country || appNote.NOT_AVAILABLE}
												</span>
											</Grid>
										</Grid>
									</div>
								</div>
							</div>
						</>
					)
				};
			</>
		)
	}
}


export default PhoneSubscriberDetailsComponent;
